const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2496 2496",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M425.704,1248l1.317,482.757l410.197,241.379l-0,282.632l-650.259,-381.378l-0,-766.56l238.745,141.17Zm-0,-482.757l-0,281.316l-238.892,-141.316l0,-281.316l238.892,-141.316l240.062,141.316l-240.062,141.316Zm582.819,-141.316l238.892,-141.316l240.062,141.316l-240.062,141.316l-238.892,-141.316Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.326,1630.69l0,-282.633l238.892,141.317l-0,281.315l-238.892,-139.999Zm410.197,442.673l238.892,141.316l240.062,-141.316l-0,281.316l-240.062,141.316l-238.892,-141.316l0,-281.316Zm821.565,-1449.44l238.891,-141.316l240.062,141.316l0,281.316l-240.062,141.316l0,-281.316l-238.891,-141.316Zm238.891,1106.83l1.317,-482.757l238.892,-141.316l-0,766.559l-650.259,381.378l-0,-282.632l410.05,-241.232Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1897.67,1630.69l-238.892,139.999l0,-281.315l238.892,-141.317l-0,282.633Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1897.67,865.305l1.317,282.633l-411.368,241.378l0,483.927l-238.892,140l-238.891,-140l-0,-483.927l-411.368,-241.378l0,-282.633l239.916,-141.316l408.881,242.549l411.367,-242.549l240.062,141.316l-1.024,0Zm-1299.35,-482.61l649.089,-382.695l650.259,382.695l-238.892,141.316l-411.367,-242.549l-410.197,242.549l-238.892,-141.316Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.fa09961e6eecab665013992d45815b4c.svg";
export { ForwardRef as ReactComponent };